export default __webpack_public_path__ + "static/media/errorViewBackground-380x600.f5cb7f5d.webp";